// extracted by mini-css-extract-plugin
module.exports = {"link":"BaseStyle_link__21w1s","altlink":"BaseStyle_altlink__A5Xs9","progress":"BaseStyle_progress__242Ll","loadingInfo":"BaseStyle_loadingInfo__1PbNc"};